import React, { useEffect } from 'react';
import { Brain } from 'lucide-react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-3 mb-8">
          <Brain className="h-8 w-8 text-purple-400" />
          <h1 className="text-3xl font-bold gradient-text">Privacy Policy</h1>
        </div>

        <div className="card p-8 space-y-6">
          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">1. Information We Collect</h2>
            <div className="space-y-4 text-gray-300">
              <p>We collect the following types of information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Client ID (automatically generated for tracking achievements and likes)</li>
                <li>Email address (if you subscribe to our newsletter)</li>
                <li>Account information (if you create an account)</li>
                <li>Usage data (likes, challenges completed, achievements earned)</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">2. How We Use Your Information</h2>
            <div className="space-y-4 text-gray-300">
              <p>We use the collected information to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Track your progress and achievements</li>
                <li>Maintain your daily streaks</li>
                <li>Send you newsletter updates (if subscribed)</li>
                <li>Improve our website and user experience</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">3. Data Storage</h2>
            <div className="space-y-4 text-gray-300">
              <p>Your data is stored securely using Supabase's infrastructure. We implement appropriate security measures to protect your information.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">4. Cookies and Local Storage</h2>
            <div className="space-y-4 text-gray-300">
              <p>We use local storage to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Store your client ID</li>
                <li>Remember your preferences</li>
                <li>Maintain your session</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">5. Third-Party Services</h2>
            <div className="space-y-4 text-gray-300">
              <p>We use the following third-party services:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Supabase for database and authentication</li>
                <li>Google AdSense for advertisements</li>
                <li>Unsplash for images</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">6. Contact</h2>
            <div className="space-y-4 text-gray-300">
              <p>For privacy-related concerns, you can reach us through our social media channels listed in the footer.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold gradient-text mb-4">7. Updates to Privacy Policy</h2>
            <div className="space-y-4 text-gray-300">
              <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;